/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the names of all the linked lists available for @see {@link Synqo.Cloud.Stammdaten.Model.Api.ApiContact}
 */
export class ContactLinkLists {
    /**
     * Represents a list of linked addresses
     */
    static readonly addresses: string = 'addresses';
}
